import componentStyles from './alert-banner.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {html} from "lit";

export default class AlertBanner extends OutlineElement {
  static styles = [super.styles, componentStyles];

  render() {
    return html`
      <slot name="flag"></slot>
      <slot name="alerts"></slot>
    `;
  }
}

customElements.define('hf-alert-banner', AlertBanner);
